export default {
  regionId: 923,
  token: '3ef26e34016983d031829266482cf50f',
  src: 'https://cpa.ostrovok.ru/static/widget/scripts/3ef26e34016983d031829266482cf50f.js',
  regionName: 'Чебоксары, Россия'
}
